module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bXqjT"))).then(() => parcelRequire('d0iPb'));